import * as types from '../../../constants/actionTypes';

const subCompanyReducer = (state = {}, action = {}) => {
    if (!action.meta || action.meta.companyId !== state.id) {
        return {
            ...state,
            loading: false,
            error: null,
        };
    }

    switch (action.type) {
        case types.CONNECTED_COMPANIES_ADD:
            return {
                ...state,
                error: null,
                loading: true,
            };
        case types.CONNECTED_COMPANIES_ADD_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                connected: true,
            };
        case types.CONNECTED_COMPANIES_ADD_FAIL:
            return {
                ...state,
                error: action.error,
                loading: false,
                connected: false,
            };
        case types.CONNECTED_COMPANIES_DELETE:
            return {
                ...state,
                error: null,
                loading: true,
            };
        case types.CONNECTED_COMPANIES_DELETE_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                connected: false,
            };
        case types.CONNECTED_COMPANIES_DELETE_FAIL:
            return {
                ...state,
                error: action.error,
                loading: false,
                connected: true,
            };
        default:
            return state;
    }
};

export default function reducer(
    state = {
        subCompanies: [],
        error: null,
        loading: true,
    },
    action = {}
) {
    switch (action.type) {
        case types.CONNECTED_COMPANIES_FETCH_ALL_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                subCompanies: action.result.map((s) =>
                    subCompanyReducer(s, action)
                ),
            };
        case types.CONNECTED_COMPANIES_ADD:
        case types.CONNECTED_COMPANIES_ADD_SUCCESS:
        case types.CONNECTED_COMPANIES_ADD_FAIL:
        case types.CONNECTED_COMPANIES_DELETE:
        case types.CONNECTED_COMPANIES_DELETE_SUCCESS:
        case types.CONNECTED_COMPANIES_DELETE_FAIL:
            return {
                ...state,
                error: null,
                loading: false,
                subCompanies: state.subCompanies.map((s) =>
                    subCompanyReducer(s, action)
                ),
            };
        case types.CONNECTED_COMPANIES_FETCH_ALL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
